import { createApiSlice } from "@common";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  CRUD_PROSPECT_CONTACT,
  CRUD_PROSPECT_CONTACT_BY_ID,
  CRUD_PROSPECT_CONTACT_PROSPECT_ID,
  DOWNLOAD_PROSPECT_CONTACT,
  UPLOAD_PROSPECT_CONTACT
} from "@routes";
import axios from "axios";
// Define the API config array
const apiConfig = [
  {
    name: "addProspectContact",
    method: "post",
    url: CRUD_PROSPECT_CONTACT,
    stateKey: "message",
  },
  {
    name: "getProspectContact",
    method: "get",
    url: CRUD_PROSPECT_CONTACT_PROSPECT_ID,
    stateKey: "data",
  },
  {
    name: "updateProspectContact",
    method: "put",
    url: CRUD_PROSPECT_CONTACT,
    stateKey: "message",
  },
  {
    name: "deleteProspectContact",
    method: "delete",
    url: CRUD_PROSPECT_CONTACT,
    stateKey: "message",
  },
  {
    name: "getProspectContactDetailsById",
    method: "get",
    url: CRUD_PROSPECT_CONTACT_BY_ID,
    stateKey: "details",
  },
  {
    name: "uploadProspectContactFile",
    method: "post",
    url: UPLOAD_PROSPECT_CONTACT,
    stateKey: "message",
  },
];
export const downloadProspectContactData = createAsyncThunk(
  "prospect/downloadProspectContactData",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      console.log("Downloading prospect data with params:", data);
      await axios
        .get(DOWNLOAD_PROSPECT_CONTACT, {
          params: data,
          withCredentials: true,
          responseType: "blob",
        })
        .then((res) => {
          const url = globalThis.URL.createObjectURL(new Blob([res.data]));

          const link = document.createElement("a");

          link.href = url;

          link.setAttribute("download", "ProspectContacts.xlsx");

          document.body.appendChild(link);

          link.click();
        });
    } catch (err) {
      return rejectWithValue(err.response);
    }
  }
);
// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    [downloadProspectContactData.pending]: (state) => {
      state.loading = true;
    },

    [downloadProspectContactData.fulfilled]: (state) => {
      state.loading = false;
    },

    [downloadProspectContactData.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "prospectContact",
  apiConfig,
  customReducers,
);
const prospectContactSlice = slice;

// Export the slice's reducer
export default prospectContactSlice.reducer;

// Export thunks
export const {
  addProspectContact,
  getProspectContact,
  updateProspectContact,
  deleteProspectContact,
  getProspectContactDetailsById,
  uploadProspectContactFile,
} = thunks;

// Export actions
export const { rowSelect } = actions;
